/* eslint-disable func-names */

/** @format */

const icon = document.querySelector(".open");
const fade = document.querySelector(".sidebar");
const close = document.querySelector(".close");

icon.addEventListener("click", function () {
	fade.style.marginLeft = '0%'
});

close.addEventListener("click", function () {
	fade.style.marginLeft = '-50%'
});

fade.addEventListener("click", function () {
	fade.style.marginLeft = '-50%'
});

(function() {
	let elements;
	let windowHeight;
  
	function init() {
	  elements = document.querySelectorAll('.hidden');
	  windowHeight = window.innerHeight;
	}
  
	function checkPosition() {
	  // eslint-disable-next-line no-plusplus
	  for (let i = 0; i < elements.length; i++) {
		const element = elements[i];
		const positionFromTop = elements[i].getBoundingClientRect().top;
  
		if ((positionFromTop+300) - windowHeight <= 0) {
		  element.classList.add('fade-in-element');
		  element.classList.remove('hidden');
		}
	  }
	}
  
	window.addEventListener('scroll', checkPosition);
	window.addEventListener('resize', init);
  
	init();
	checkPosition();
  })();
